// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"d0dfb05a","872":"d0dfb05a"}[chunkId] + ".chunk.css";
};